import { Injectable } from '@angular/core'
import * as signalR from '@microsoft/signalr'
import { AppConfigService } from './app-config.service'

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  public hasRemoteConnection: boolean
  public hubConnection: signalR.HubConnection
  public hubUrl: string
  public hubName: string

  constructor(public appConfigService: AppConfigService) {}

  public startConnection() {
    let hubUrl = this.appConfigService.getApiUrlWithEndpoint(this.hubName)

    this.hubConnection = new signalR.HubConnectionBuilder().withUrl(hubUrl).withAutomaticReconnect().build()

    return this.hubConnection
      .start()
      .then(() => {
        this.hasRemoteConnection = true

        this.hubConnection.onclose(() => {
          this.hasRemoteConnection = false
        })
      })
      .catch(() => {
        this.hasRemoteConnection = false
      })
  }

  public registerEvent(eventName: string, callbackFunction) {
    let event = () => {
      this.hubConnection.on(eventName, (data) => callbackFunction(data))
    }

    return this.startConnection().then(event)
  }
}
